
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Event Info */}
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              XX San Silvestre Zaragoza
            </h3>
            <p className="text-gray-300 mb-4">
              La carrera popular nocturna más divertida de Zaragoza. 
              ¡Despide el año corriendo por el centro histórico!
            </p>
          </div>

          {/* Event Details */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Detalles del Evento</h4>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center">
                <i className="ri-calendar-line mr-2"></i>
                <span>31 de Diciembre 2025</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                <span>18:00 horas</span>
              </div>
              <div className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                <span>Calle Coso, Zaragoza</span>
              </div>
              <div className="flex items-center">
                <i className="ri-route-line mr-2"></i>
                <span>5 kilómetros</span>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <div className="space-y-3 text-gray-300">
              <div>
                <p className="font-medium">Agrupación Deportiva</p>
                <p>Atlética Jerónimo Zurita</p>
              </div>
              <div>
                <p>Zaragoza, España</p>
              </div>
              <div>
                <a 
                  href="mailto:sansilvestrezaragozana@gmail.com"
                  className="text-red-400 hover:text-red-300 transition-colors cursor-pointer"
                >
                  sansilvestrezaragozana@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col md:flex-row items-center gap-4">
              <p className="text-gray-400 text-sm">
                Inscripciones gestionadas por{' '}
                <a 
                  href="https://www.avaibooksports.com/inscripcion/xx-san-silvestre-zaragoza-el-rincon-2025/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-400 hover:text-blue-300 transition-colors cursor-pointer"
                >
                  AvaiBookSports.com
                </a>
                {' '}© 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
